/**
 * @file user_analytics.tsx
 *
 * @fileoverview helper functions for the user analytics events.
 */

import { DIMENSIONS, setEventParams } from '~/jobiqo/lib/analytics';
import { isRecruiter } from '~/jobiqo/lib/auth';
import { User } from '~/jobiqo/models/user';
import { concatArrayItems } from '~/jobiqo/utils/mapper';

/**
 * Returns the dimensions for a given user.
 *
 * @param {User} user
 *   The user to return dimensions for.
 * @param {string} signupMethod
 *   The login method, overrides the one stored by the OAuth sign in.
 * @returns {Object}
 *   The dimensions object for this user.
 */
export const getUserDimensions = (user: User, signupMethod?: string) => {
  const isUserRecruiter = isRecruiter(user);

  return setEventParams({
    [DIMENSIONS.organization_name]: isUserRecruiter ? user.name : '',
    [DIMENSIONS.current_user_id]: user.id,
    [DIMENSIONS.user_role]: concatArrayItems(user.roles, 'targetId'),
    [DIMENSIONS.owner_id]: user.organization?.ownerId,
    [DIMENSIONS.organization_id]: user.organization?.id,
    [DIMENSIONS.signup_method]:
      signupMethod ?? sessionStorage.getItem('signup_method'),
  });
};
